import { makeRoutes, MakeRoutesOpts } from "common/router/utils/routes";
import { MakePaths } from "common/router/types";
import { makeUrls } from "common/router/utils/urls";

const paths = {
  paymentUpdate: "/care-plan-payment",
};

/** matches links CarePlanPaymentLinkRule */
type CarePlanPaymentSearch = {
  patient_care_ids: string;
};

type CarePlanPathDefinitions = {
  paymentUpdate: { Search: CarePlanPaymentSearch };
};

export type CarePlanPaths = MakePaths<CarePlanPathDefinitions>;

export const useCarePlanRoutes = (opts: MakeRoutesOpts) => {
  return makeRoutes(opts, [
    {
      path: paths.paymentUpdate,
      element: () => import("../components/CarePlanPaymentUpdatePage"),
    },
  ]);
};

export const makeCarePlanUrls = (base: string) => {
  return makeUrls<CarePlanPathDefinitions>(base, {
    paymentUpdate: { path: paths.paymentUpdate },
  });
};
